export const SCHOOL = {
  name: "Eletech Global Ontario School",
  short: "Eletech",
  email: "info@eletech.ca",
  phone: "+1 (416) 555-0182",
  address: "354 Rymal Rd E, Hamilton, ON, Canada L9B 1C3",
  hours: "Monday to Friday, 9:00 a.m. to 5:00 p.m. ET",
};

export const STATS = [
  { value: 100, suffix: "%", label: "higher education admission for OSSD students" },
  { value: 12000, suffix: "+", label: "OSSD credits earned" },
  { value: 74, suffix: "", label: "Ontario curriculum courses, Grades 9–12" },
  { value: 4, suffix: " weeks", label: "fastest course completion, 12-month access" },
];

export const TRUST = [
  { title: "Ministry-Inspected", desc: "Inspected by the Ontario Ministry of Education and authorized to grant OSSD credits." },
  { title: "Ontario Certified Teachers", desc: "Every course is designed and delivered by OCT-certified subject teachers." },
  { title: "University-Recognized", desc: "Transcripts are accepted by universities and colleges across Canada and abroad." },
  { title: "Enrol 365 Days a Year", desc: "Start any day you like. No semesters, no waitlists, no fixed timetable." },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "School that bends to your life",
    text: "Athletes, performers, travellers, part-time workers — your timetable should serve your ambition, not the other way around. Study from any location, at the time that suits you best and at your own pace.",
    accent: "Your education in your control.",
  },
  {
    num: "02",
    title: "A Ministry-Inspected School with OCT-certified educators",
    text: "We are inspected by the Ontario Ministry of Education and fully authorized to deliver formal credits and grant the Ontario Secondary School Diploma. Ontario Certified Teachers ensure fast and proper assessment, with personalized support and feedback.",
    accent: "Inspected. Certified. Trusted.",
  },
  {
    num: "03",
    title: "Boost your profile for university admission",
    text: "Improve your grade or fill the prerequisite gaps with selective credits. International students get streamlined admission with a globally recognized Canadian high school diploma.",
    accent: "Improve. Stand out. Get your offer.",
  },
];

export const STEPS = [
  { num: "1", title: "Enrol any day", text: "Create your application online in minutes and start the same day — there are no semesters or start dates." },
  { num: "2", title: "Learn at your pace", text: "Work through teacher-built lessons, examples and practice at the time of day that works for you." },
  { num: "3", title: "Submit assignments", text: "Send your work to your teacher and receive meaningful, personal feedback within days — not weeks." },
  { num: "4", title: "Write your final exam", text: "Sit a proctored final exam online, from home, on a date you choose. Proctoring is included in every course." },
  { num: "5", title: "Earn your credit", text: "Your report card and transcript are issued promptly and can be sent directly to OUAC, OCAS, universities or day schools." },
];

export const TESTIMONIALS = [
  {
    name: "Maya R.",
    path: "Software Engineering, University of Waterloo",
    quote: "I took Calculus alongside my day-school classes so I could graduate early. The pace was completely mine, and my teacher answered every single question within a day.",
  },
  {
    name: "Daniel O.",
    path: "Nursing, McMaster University",
    quote: "I needed a chemistry upgrade for my nursing offer. From registration to final exam, everything took five weeks — and my mark rose twelve points.",
  },
  {
    name: "Priya S.",
    path: "Life Sciences, University of Toronto",
    quote: "Between training and travel, a fixed timetable never worked for me. I wrote my exam from home and my transcript still reached OUAC right on time.",
  },
  {
    name: "Lucas M.",
    path: "International student, Vancouver",
    quote: "As a student joining from outside Ontario, the diploma pathway was clear from day one. My transcript was sent to universities the same week I finished my last exam.",
  },
  {
    name: "Emma T.",
    path: "Design, York University",
    quote: "The courses are visual, organized and honestly enjoyable. I always knew what was due, what it was worth, and exactly where my mark stood.",
  },
  {
    name: "Jacob F.",
    path: "Business, Western University",
    quote: "I retook two courses to raise my average. The upgrade format was focused, fair and fast — and my guidance counsellor saw the new marks immediately.",
  },
];

export const UNIVERSITIES = [
  "University of Toronto",
  "University of Waterloo",
  "McMaster University",
  "McGill University",
  "University of British Columbia",
  "Western University",
  "Queen's University",
  "York University",
  "University of Alberta",
  "Université de Montréal",
  "University of Calgary",
];

export const FAQS = [
  {
    category: "Getting Started",
    items: [
      {
        q: "Who can take courses at EGOS?",
        a: "Anyone who wants an Ontario credit: students currently attending an Ontario day school, students from other provinces, international students studying from home, homeschoolers, and mature students returning to finish their diploma. If you can study online, you can start.",
      },
      {
        q: "Can I take just one course, or do I have to earn the whole diploma with EGOS?",
        a: "Both work. Many students take a single credit to upgrade a mark or fill a prerequisite, while others complete the entire OSSD with us. You can also begin part-time and move to full-time later — your earned credits carry forward.",
      },
      {
        q: "What equipment do I need to study online?",
        a: "Any laptop, tablet or phone with a reliable internet connection and an updated browser. Lessons, assignments, quizzes and your proctored final exam all run through our learning platform — there is nothing to install.",
      },
      {
        q: "I'm not sure I have the prerequisite for a course. What should I do?",
        a: "Ask our guidance team before you register. They will review your academic background, confirm whether you meet the prerequisite, and recommend the right course or pathway.",
      },
    ],
  },
  {
    category: "Courses & Scheduling",
    items: [
      {
        q: "How quickly can I finish a course?",
        a: "It is entirely up to you. You can complete a full credit in as little as four weeks, or stretch your learning over up to twelve months. There are no semesters — you set the calendar.",
      },
      {
        q: "Can I take a course while attending my regular day school?",
        a: "Yes — most of our students do exactly that. Our credits are recorded on the official Ontario Student Transcript and can be forwarded to your day school, or counted toward your diploma directly with us.",
      },
      {
        q: "Can I upgrade a mark I already earned?",
        a: "Absolutely. If you have already passed a course and want a stronger mark, our focused upgrade courses let you concentrate on the units that raise your average fastest.",
      },
      {
        q: "Can I study in my own timezone?",
        a: "Yes. Courses are fully self-paced and asynchronous — there are no live classes to attend. Work at any hour from anywhere in the world, and your teacher will reply within one business day.",
      },
      {
        q: "Can I switch from part-time to full-time?",
        a: "Yes. Many students start with a single course and later decide to complete their whole diploma with EGOS. Because every credit is recorded on the Ontario Student Transcript, nothing is wasted.",
      },
    ],
  },
  {
    category: "Accreditation & OSSD",
    items: [
      {
        q: "Will universities and colleges accept my credits?",
        a: "Yes. We are a ministry-inspected private school in Ontario authorized to grant OSSD credits. Your transcript is recognized by universities and colleges across Canada and around the world, and can be submitted directly through OUAC/OCAS.",
      },
      {
        q: "What do I need to earn the Ontario Secondary School Diploma?",
        a: "For students who started Grade 9 in Fall 2024 or after: thirty credits (seventeen compulsory and thirteen elective), forty hours of community involvement, two online learning credits — which our courses cover automatically — and the provincial literacy requirement. Our guidance team tracks all of it with you from day one.",
      },
      {
        q: "How is my work graded?",
        a: "Every assignment is marked by an Ontario Certified Teacher with written feedback. Your final grade follows the Ontario achievement-chart categories, with a proctored final exam worth a defined portion of your mark.",
      },
      {
        q: "Will my previous coursework count toward the OSSD?",
        a: "In many cases, yes. Through PLAR (Prior Learning Assessment and Recognition), we review transcripts from another province or country, and grant credits for coursework that closely matches Ontario's curriculum — so you never retake what you have already completed.",
      },
      {
        q: "How do I meet the \"Community hours\" requirements?",
        a: "You need to complete a minimum of 40 hours of unpaid community involvement. Examples include hospitals, retirement homes, offices of local government, and religious or cultural events. Ineligible activities include operating a vehicle, handling medication, and similar. You need to get prior approval from EGOS before finalizing the activity, and you need to track your hours.",
      },
      {
        q: "Do out-of-province students follow different diploma requirements?",
        a: "No. The OSSD requirements are the same for everyone — thirty credits, forty community-involvement hours and the literacy requirement. We set up your Ontario Student Record with EGOS and assess your prior credits for equivalency.",
      },
      {
        q: "How do I meet the literacy requirement?",
        a: "Students can meet the provincial literacy requirement for graduation by successfully passing the Ontario Secondary School Literacy Test (OSSLT) administered by EQAO. Alternatively, students who are eligible and have been unsuccessful on the test at least once can take the Ontario Secondary School Literacy Course (OLC4O) from us.",
      },
    ],
  },
  {
    category: "Exams & Assessments",
    items: [
      {
        q: "How do final exams work?",
        a: "Every course ends with a proctored final exam written online from wherever you are, on a date you schedule. Proctoring is included in your course fee — there is nothing extra to arrange.",
      },
      {
        q: "When do I get my report card and transcript?",
        a: "Report cards are issued within days of your final exam, and official transcripts can be sent electronically to OUAC, OCAS, universities, colleges or your day school whenever you need them.",
      },
      {
        q: "When am I ready to book my final exam?",
        a: "When your coursework is complete — there is no fixed exam session. You choose the exam date that suits you and write from home under online proctoring, in any timezone.",
      },
    ],
  },
  {
    category: "Tuition & Enrolment",
    items: [
      {
        q: "When can I start?",
        a: "Any day. Registration is open 365 days a year — once your application is processed you receive immediate access to your course, and your teacher reaches out personally to welcome you.",
      },
      {
        q: "How much does a course/credit cost?",
        a: "A flat per-credit fee: $490 CAD for Canada based students and $890 CAD for International students. It includes — course materials, learning portal access, assessment and grading, teacher support and your proctored final exam. No hidden costs, ever. Discounts may be applicable.",
      },
      {
        q: "How can I get scholarship/discount on the tuition fees?",
        a: "You can get a discount for registering for multiple credits at the same time. These are built into the admission form, where you'll select your courses for paying the fees. The minimum credits required are 3 for Ontario-based students, while 6 for Out-of-province and International students.",
      },
      {
        q: "What currency do you charge in?",
        a: "All fees are in Canadian dollars (CAD), payable by major credit card. The per-credit price on our Tuition page is the full price — course materials, support and proctored exam included.",
      },
      {
        q: "Do you accept international students?",
        a: "Yes — students in Canada and around the world can earn the OSSD with us entirely online, with report cards and transcripts delivered to institutions worldwide.",
      },
      {
        q: "Do I need a study permit to start a course?",
        a: "No. Studying online from your home country requires no study permit and no travel — you only apply for one if you are later accepted to a Canadian university for on-campus study.",
      },
      {
        q: "Can I cancel my registration and get refund?",
        a: "Tuition fees refunds are possible if you immediately reach out after making the payment. Administrative fees are non-refundable.",
        link: { label: "Please see Refund Policy", to: "/refund-policy" },
      },
    ],
  },
];

export const PRICING = {
  domestic: 490,
  international: 890,
  includes: [
    "Full course access for up to 12 months",
    "One-on-one support from your OCT teacher",
    "All learning materials and resources",
    "Tutoring whenever you need it",
    "Proctored online final exam",
    "Report card and transcript management",
    "24X7 available learning platform",
  ],
};

export const ADMIN_FEES = [
  { name: "EGOS as Full-Time School + OSR setup", price: 200, note: "Setting up your Ontario Student Record (OSR) with EGOS as your Full-Time School — applies to the OSSD from EGOS pathway. Paid at the time of courses/credits registration.", cart: null },
  { name: "PLAR assessment", price: 200, note: "One-time review of your previous transcripts for credit equivalency", cart: "plar" },
  { name: "Course transfer", price: 150, note: "Change the credit you initially registered, within 7 days of registration", cart: "transfer" },
  { name: "Course extension, per month", price: 70, note: "Continue an unfinished course beyond the included 12-month access period", cart: "extension" },
];

export const REFUND_POLICY = [
  {
    q: "Within 3 hours of payment",
    a: "You may withdraw from a credit if you notify us via email within 3 hours of paying for it — you'll receive a refund minus 5% for the payment processing fees.",
  },
  {
    q: "Within 24 hours and before your course starts",
    a: "You may withdraw from a credit if you notify us via email within 24 hours of paying for it and if it has not been accessed on the learning platform — you'll receive a refund minus 25% for the administrative and payment processing fees.",
  },
  {
    q: "After 24 hours or accessing it on LMS",
    a: "If it has been 24 hours since you paid for the credit — or if it's less than 24 hours but you've started accessing the learning platform or the course/credit on LMS — no refunds are possible. Your credit and included support remain yours for the full access period.",
  },
  {
    q: "Within 7 days",
    a: "You can request to transfer/replace your registered credit with another course available with us, if you haven't taken any assessments and if you have the prerequisite to register for the new course.",
  },
  {
    q: "If multiple credits were paid together",
    a: "Any bundled discount/scholarship offered for registering multiple credits is removed — the credits you keep are repriced at the regular undiscounted rate — and the balance is used for refund calculation.",
  },
  {
    q: "Administrative fees",
    a: "Administrative fees including PLAR assessment, Course transfer, Course extension etc are not refundable. You need to provide any documents asked by the school, within 7 days of school reaching out to you.",
  },
];

export const REFUND_OSSD_TERMS = {
  intro:
    "Credits/course registration has been completed for the OSSD through EGOS, but the following conditions were not met to the admissions team's satisfaction within 7 days of receiving the initial request from EGOS:",
  conditions: [
    "Required acceptable documents were not submitted. You need to provide clearly legible official documents in English, and prove their authenticity if questioned by EGOS.",
    "The minimum required credits by EGOS were not registered. You need to register for the balance of the credits with EGOS.",
    "A credit was registered, but its prerequisites have not been completed. You need to register for the prerequisite credit with EGOS.",
    "Acceptable government ID and proof of residency were not submitted.",
    "Prior education official transcripts were not submitted.",
    "The completed OSR transfer/request form was not submitted to make EGOS your only full-time school.",
    "Approved proof of community hours completion from your previous school was not submitted.",
    "All documents must be in English. If required, they must be translated by registered, authorized translation providers.",
  ],
  ossdIntro: "Additionally, the following conditions must be met before an OSSD can be issued:",
  ossdConditions: [
    "Acceptable proof of 40 community hours completion has been submitted.",
    "Proof of passing the OSSLT has been provided, or OLC4O has been completed with EGOS.",
  ],
  notes: [
    "At EGOS's sole discretion, we can cancel your OSSD admission while allowing the registered credits to be completed as individual credits. Fees paid exclusively for full-time school registration will be refunded after a 50% administrative fee deduction. No other refunds will be allowed, including for credit registration, course transfers, course extensions, PLAR fees, etc.",
    "If any credit needs to be cancelled or transferred — irrespective of whether the request is initiated by the student, parents, previous school, EGOS, or any other authority — the refund and credit transfer policy applies.",
  ],
  bundledRule:
    "If credits are registered separately at different times rather than bundled together, the bundled discount policy will not apply. For example, if the bundled discount requires registering for 6 credits at once, a student who initially registers for 4 credits and later registers for 2 additional credits for any reason, will not qualify for the discount, and no refunds will be issued.",
};
